import { Modifier, ModifierArguments, VirtualElement } from '@popperjs/core';

function isElement(el: HTMLElement | VirtualElement): el is HTMLElement {
  return (el as HTMLElement).offsetWidth !== undefined;
}

type CreateSameWidthModifierArgs = {
  enabled: boolean;
};

function sameWidthFn({ state }: ModifierArguments<Record<string, never>>) {
  state.styles.popper.width = `${state.rects.reference.width}px`;
}

function sameWidthEffect({ state }: ModifierArguments<Record<string, never>>) {
  const { reference } = state.elements;

  const width = isElement(reference)
    ? reference.offsetWidth
    : reference.getBoundingClientRect().width;

  state.elements.popper.style.width = `${width}px`;
}

// https://codesandbox.io/s/bitter-sky-pe3z9?file=/src/index.js
const sameWidthModifier = ({
  enabled,
}: CreateSameWidthModifierArgs): Modifier<
  'sameWidth',
  Record<string, never>
> => ({
  name: 'sameWidth',
  enabled,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  // NB: keep function references stable to avoid infinite loop
  fn: sameWidthFn,
  effect: sameWidthEffect,
});

export default sameWidthModifier;
